
webpack.register(
    'modules/right-rail/tv-schedule/tv-schedule',
    function() {
        return import('modules/right-rail/tv-schedule/tv-schedule');
    },
    true
);